import React, { useCallback } from "react";
import useStore from "../../../context/useStore";
import Loader from "../../common/Loader";
import FormRdv from "../FormRDSP/FormRdv";
import useRecipientData from "../../../hooks/useRecipientData/useRecipientData";
import { FicheSection, Pill } from "../../common/Fiche";
import useEspaceAllocataire from "./useEspaceAllocataire";
import MesRendezVous from "./MesRendezVous";
import MesDocuments from "./MesDocuments";
import MonCompte from "./MonCompte";
import MonParcours from "./MonParcours";
import "./espace-allocataire.scss";

export const capitaliser = (mot) =>
  mot ? mot.charAt(0).toUpperCase() + mot.slice(1).toLowerCase() : "";

// Espace allocataire : accueil (prénom, état des droits, organisme), puis une
// carte par sujet, dans l'ordre des besoins : prochaine étape ou rendez-vous,
// documents, compte, parcours. Une colonne, lisible sur téléphone.
const Dashboard = ({ history }) => {
  const [state] = useStore();
  const user = state.auth.user;
  const { setRecipient } = useRecipientData();

  const versQuestionnaire = useCallback(() => history.push("/rdsp?redirectfrombo"), [history]);
  const espace = useEspaceAllocataire({
    userId: user.id,
    onQuestionnaireManquant: versQuestionnaire,
    onAllocataire: setRecipient,
  });
  const { droitsOuverts, allocataire, evenements, rdspId, hasRdv, rdvs, reponses, organisme, errors } = espace;

  if (!espace.pret) {
    return (
      <div className="espace">
        <Loader text="Veuillez patienter, nous préparons votre espace" />
      </div>
    );
  }

  const prenom = capitaliser(user.firstname || (allocataire && allocataire.firstname));

  return (
    <div className="espace">
      {errors.other && (
        <div className="alert alert-danger" role="alert">
          {errors.other}
        </div>
      )}

      <header className="accueil list-card">
        <p className="accueil__eyebrow">Votre espace allocataire</p>
        <h1 className="accueil__titre">{prenom ? `Bonjour ${prenom}` : "Bonjour"}</h1>
        <p className="accueil__droits">
          {droitsOuverts === true && (
            <Pill tone="ok" icon="fa-check">
              Vos droits RSA sont ouverts
            </Pill>
          )}
          {droitsOuverts === false && (
            <>
              <Pill tone="warn" icon="fa-clock">
                Vos droits RSA ne sont pas encore ouverts
              </Pill>
              <span>Vous serez informé(e) par mail dès que votre situation évoluera.</span>
            </>
          )}
        </p>
        {organisme && (
          <p className="accueil__organisme">
            Vous êtes accompagné(e) par <strong>{organisme.name}</strong>.
          </p>
        )}
      </header>

      {rdspId && !hasRdv && (
        <FicheSection id="prochaine-etape" title="Votre prochaine étape">
          <FormRdv
            rdspId={rdspId}
            userData={user}
            setRdvTaken={espace.rafraichir}
            hasDroit={droitsOuverts === true}
            niveauTitre={3}
          />
        </FicheSection>
      )}

      {hasRdv && (
        <FicheSection
          id="rendez-vous"
          title="Vos rendez-vous"
          intro="Vos rendez-vous avec votre organisme d'accompagnement. Un rendez-vous à venir peut être reporté."
        >
          {rdvs ? (
            <MesRendezVous
              rdvs={rdvs}
              recipientId={user.id}
              rdspId={rdspId}
              onReported={() => {
                espace.chargerRdvs();
                espace.rafraichir();
              }}
            />
          ) : (
            <Loader />
          )}
        </FicheSection>
      )}

      {allocataire && (
        <FicheSection id="documents" title="Vos documents">
          <MesDocuments reponses={rdspId ? reponses : null} allocataire={allocataire} />
        </FicheSection>
      )}

      {allocataire && (
        <FicheSection id="compte" title="Votre compte">
          <MonCompte allocataire={allocataire} />
        </FicheSection>
      )}

      <FicheSection id="parcours" title="Votre parcours" intro="Les étapes de votre dossier à la Caf.">
        <MonParcours evenements={evenements} />
      </FicheSection>
    </div>
  );
};

export default Dashboard;
